providerCabinetApp
  .constant('OPC_CONFIG', window.OPC_CONFIG)
  .constant('API_BASE_URL', window.API_BASE_URL || "");
